import { Get } from '../helpers';
import { TemplateCategoriesListItem } from '@/types/template.types';

const FetchTemplateCategories = ({ channel }: { channel: number }): Promise<TemplateCategoriesListItem[]> => {
  return Get({
    path: `/v3/admin/templates-category-filters/channels/${channel}/categories-with-events`,
  });
};

export default FetchTemplateCategories;
